module.exports = __webpack_public_path__ + "static/img/__8383.8c2a91b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__8383.jpg
// module id = 3/q7
// module chunks = 0